/**
 *
 * Module:        Theme Utility
 * Name:          Guru Typography
 * Description:   Defines the shared modern typography for the complete Guru interface
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

export const GURU_FONT_FAMILY = [
	'"Segoe UI Variable Text"',
	'"Segoe UI Variable"',
	'Inter',
	'-apple-system',
	'BlinkMacSystemFont',
	'"Segoe UI"',
	'Roboto',
	'Helvetica',
	'Arial',
	'sans-serif'
].join(', ');

export const GURU_BODY_FONT_SIZE = '1rem';
export const GURU_META_FONT_SIZE = '0.875rem';

export const createGuruTypography = typography => ({
	...typography,
	fontFamily: GURU_FONT_FAMILY,
	fontSize: 16,
	body1: {
		...typography.body1,
		fontFamily: GURU_FONT_FAMILY,
		fontSize: GURU_BODY_FONT_SIZE,
		fontWeight: 400,
		lineHeight: 1.5
	},
	body2: {
		...typography.body2,
		fontFamily: GURU_FONT_FAMILY,
		fontSize: GURU_BODY_FONT_SIZE,
		fontWeight: 400,
		lineHeight: 1.5
	},
	button: {
		...typography.button,
		fontFamily: GURU_FONT_FAMILY,
		fontSize: GURU_BODY_FONT_SIZE,
		fontWeight: 500,
		lineHeight: 1.5,
		textTransform: 'none'
	}
});
